import * as Radix from "@radix-ui/react-popover";
import { cn } from "../utils/tailwind";
import {
  forwardRef,
  type ElementRef,
  type ComponentPropsWithoutRef,
} from "react";

export const Root = Radix.Root;

export const Trigger = Radix.Trigger;

export const Anchor = Radix.Anchor;

export const Arrow = (props: Radix.PopoverArrowProps) => (
  <Radix.Arrow {...props} className="opacity-10" />
);

export const Portal = Radix.Portal;

export const Content = forwardRef<
  ElementRef<typeof Radix.Content>,
  ComponentPropsWithoutRef<typeof Radix.Content>
>(({ className, align = "center", sideOffset = 4, ...props }, ref) => (
  <Portal>
    <Radix.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className,
      )}
      {...props}
    />
  </Portal>
));
